import { Image, Text, View } from '@react-pdf/renderer';
import { DateTime } from 'luxon';

import { commonStyles } from 'src/common/pdf/common.styles';

export interface VehicleInspectionReportHeaderProps {
  organizationName: string;
  logo?: string;
  inspectionDate: string;
}
export function VehicleInspectionReportHeader({
  organizationName,
  logo,
  inspectionDate,
}: VehicleInspectionReportHeaderProps) {
  const date = DateTime.fromISO(inspectionDate);

  return (
    <View fixed style={{ marginTop: 10 }}>
      <View style={[commonStyles.between, { flexDirection: 'row' }]}>
        <View style={commonStyles.hstack}>
          {logo ? (
            <Image src={logo} style={commonStyles.organizationLogo} />
          ) : null}
          <View style={[commonStyles.vstack, { gap: 4 }]}>
            <Text style={[commonStyles.strong]}>{organizationName}</Text>
          </View>
        </View>
        <View style={[commonStyles.vstack]}>
          <View style={[commonStyles.hstack]}>
            <Text>Date:</Text>
            <Text style={commonStyles.strong}>
              {date.toLocaleString(DateTime.DATE_SHORT)}
            </Text>
          </View>
          <View style={[commonStyles.hstack]}>
            <Text>Time:</Text>
            <Text style={commonStyles.strong}>
              {date.toLocaleString(DateTime.TIME_SIMPLE)}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}
